import { COLORS } from "layouts/ThemeProvider/palette";

export default {
  MuiOutlinedInput: {
    root: {
      borderRadius: 5,
      "&$error": {
        "& $input": {
          backgroundColor: COLORS.melon,
          color: COLORS.radicalRed,
        },
        "& $notchedOutline": {
          borderColor: COLORS.flamingo,
        },
      },
    },
    input: {
      padding: [10, 9],
      height: 30,
      border: "none",
      color: COLORS.havelockBlue,
      fontSize: 15,
      "&:placeholder-shown": {
        background: COLORS.polar,
      },
      "@media (min-width: 780px)": {
        padding: [10, 16],
        fontSize: 17,
      },
    },
    notchedOutline: {
      borderWidth: 2,
      borderColor: COLORS.turquoise,
    },
    multiline: {
      background: COLORS.polar,
      "&$error": {
        backgroundColor: COLORS.melon,
      },
    },
    inputMultiline: {
      height: "auto",
      resize: "none",
      background: COLORS.polar,
    },
  },
};
